import { BIM360IssueComment } from '../BIM360IssueComment';

export class BackendBIM360IssueCommentV2 extends BIM360IssueComment {
    public static toAutodeskJSON(json: any): any
    {
        return {
            body: json.body || undefined
        }
    }


    public static fromAutodeskJSON(json: any): BackendBIM360IssueCommentV2
    {
        console.log(json);
        let comment = new BackendBIM360IssueCommentV2();
        comment.id = json.id;
        comment.issue_id = json.issueId;
        comment.body = json.body;
        comment.created_by = json.created_by;
        comment.updated_at = json.updated_at;
        return comment;
    }
}
